import { GtmService } from '~/src/services/web-analytics.service';
import { getAnalyticsEventData } from '~/src/helpers/web-analytics-events-data.helper';
import {
    WebAnalyticsActionGroupEnum,
    WebAnalyticsEventActionEnum,
    WebAnalyticsEventCategoryEnum,
    WebAnalyticsEventEnum,
} from '~/src/models/enums/web-analytics.enum';

export const onSendButtonsClickAnalytics = (label: string) => {
    GtmService.send(
        getAnalyticsEventData({
            eventAction: WebAnalyticsEventActionEnum.buttonClick,
            eventLabel: label,
            event: WebAnalyticsEventEnum.vntEvent,
            eventCategory: WebAnalyticsEventCategoryEnum.createNewLeadRef,
            actionGroup: WebAnalyticsActionGroupEnum.interactions,
        }),
    );
};
